import { render, staticRenderFns } from "./SharedLinkContent.vue?vue&type=template&id=6bebdba6&scoped=true"
import script from "./SharedLinkContent.vue?vue&type=script&lang=ts"
export * from "./SharedLinkContent.vue?vue&type=script&lang=ts"
import style0 from "./SharedLinkContent.vue?vue&type=style&index=0&id=6bebdba6&prod&lang=scss&scoped=true"
import style1 from "./SharedLinkContent.vue?vue&type=style&index=1&id=6bebdba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bebdba6",
  null
  
)

export default component.exports